<p [className]="value">{{ text }}</p>
